module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8fTsq"))).then(() => module.bundle.root('hEqeo'));